import useMedia from '../../../hooks/ui/useMedia';
import Breakpoint from '../../../types/UI/Breakpoint';

const widths: Record<Breakpoint, number> = {
    mobile: 425,
    tablet: 768,
    laptop: 1024,
    desktop: 1200,
};

const useCollapseBelow = (collapseBelow?: Breakpoint): boolean => {
    const shouldCollapse = useMedia(
        {
            [`(max-width: ${widths[collapseBelow ?? 'mobile']}px)`]: true,
        },
        false
    );

    if (!collapseBelow) {
        return false;
    }

    return shouldCollapse;
};

export default useCollapseBelow;
